import { useLocation } from 'react-router-dom';
import { Transition } from './transition';

export function AnimationLayout({ children }: { children: React.ReactNode }) {
    const { pathname } = useLocation();

    return (
        <Transition
            appear
            as="main"
            className="flex flex-col flex-1"
            enter="transition-opacity duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            key={pathname}
            leave="transition-opacity duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            show
        >
            {children}
        </Transition>
    );
}
